module.exports = __webpack_public_path__ + "img/none.4d8caebd.png";